import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardHeader,
  Container,
  Row, Button, Spinner, FormGroup, Col, Input, Label, ModalBody, ModalFooter, Modal,
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, Redirect, useHistory } from "react-router-dom";
import { Form, Field } from "react-final-form";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Select } from "@material-ui/core";
import dataProvider from "dataProvider";
import auth from "authProvider";


const UserCreate = () => {
  const history = useHistory();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedrole, setSelectedrole] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [sucess, setSucess] = useState(false);
  const [erroropen, setErroropen] = useState(false);
  const [errors, setErrors] = useState(false);

  const onLogout = () => {
    auth.logout();
    //window.location.reload();
    history.push("/")
  }

  const onChangePermission = (val, key) => {
    if (val) {
      let per = permissions;
      per.push(key);
      setPermissions(per);
    }

    else {
      const per_re = permissions;
      const index = per_re.indexOf(key);
      if (index > -1) {
        per_re.splice(index, 1);
      }
      setPermissions(per_re);
    }
  }
  const onSubmit = values => {
    setLoading(true)
    dataProvider.create('users', { params: { ...values, role: selectedrole, permissions: JSON.stringify(permissions) } })
      .then(({ data }) => {
        console.log(data)
        setLoading(false)
        setSucess(true)
        setTimeout(() => Push(), 1000);
        // history.push("/users");
      })
      .catch(error => {
        if (error?.response?.status === 400) {
          setErroropen(true)
          setErrors(error?.response?.data?.msg)
        }
        setLoading(false)
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  };
  const Push = () => {
    setSucess(false)
    history.push("/users");

  }
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h2 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', fontSize: '1.5rem' }}>CREATE USER</h2>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                <Link to="/tenants/create"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', border: 0, color: '#1e435c', fontWeight: 'bolder' }}>  <IcomoonReact iconSet={iconSet} color="#1e435c" size={14} icon="add" />  CREATE TENANT</Button>{' '}</Link>
              </div>
            </Row>
          </div>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <h3 className="mb-0">USER DETAILS</h3>
                    </CardHeader>
                    <Form
                      onSubmit={onSubmit}
                      validate={values => {
                        const errors = {};
                        function validateEmail(email) {
                          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                          return re.test(String(email).toLowerCase());
                        }
                        function validatePhone(phone) {
                          var ph = /^(\d{8}(\,\d{8}){0,2})$/;
                          return ph.test(String(phone).toLowerCase());
                        }
                        // function password(password) {
                        //   var pswrd = /^[a-zA-Z0-9!@#$%^&*]{6,16}$/;
                        //   return pswrd.test(String(password).toLowerCase());
                        // }

                        if (!values.name) {
                          errors.name = "required";
                        }
                        if (!values.email) {
                          errors.email = "required";
                        } else if (!validateEmail(values.email)) {
                          errors.email = "Enter a valid email address";
                        }
                        if (!values.phone) {
                          errors.phone = "Required";
                        } else if (!validatePhone(values.phone)) {
                          errors.phone = "Enter a valid phonenumber";
                        }
                        if (!values.username) {
                          errors.username = "required";
                        }
                        // if (!values.password) {
                        //   errors.password = "Required";
                        // } else if (!password(values.password)) {
                        //   errors.password = "Minimum Charector length of 6,Maximum Charector length 16,Password should contain atleast one number and one special charector,";
                        // }

                        if (!values.password) {
                          errors.password = "required";
                        }
                        return errors;
                      }}
                      render={({ handleSubmit, values, submitting, validating, valid, value }) => (
                        <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                          <div className="pl-lg-4">
                            <Row>
                              <Col md="12">
                                <FormGroup>
                                  <Label for="name" style={{ fontSize: ' 0.8125rem' }}>Full Name</Label>
                                  <Field name="name">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          placeholder="Enter User FullName"
                                          style={{ color: 'black' }}
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="role">Role</Label>
                                  <Field name="role" >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input required type="select" name="role" onChange={(e) => setSelectedrole(e.target.value)} style={{ color: 'black' }}>
                                          <option value=''>--Choose-</option>
                                          <option value='admin'>Administrator</option>
                                          <option value='suprevisor'>Suprevisor</option>
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="email">E-mail</Label>
                                  <Field name="email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="email"
                                          style={{ color: 'black' }}
                                          placeholder="Enter email address"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Phone Number</Label>
                                  <Field name="phone">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          style={{ color: 'black' }}
                                          placeholder="Enter Phone Number"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                          <div className="pl-lg-4">
                            <Row>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="username">User Name</Label>
                                  <Field name="username">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          style={{ color: 'black' }}
                                          placeholder="Enter User Name"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="password">Password</Label>
                                  <Field name="password">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="password"
                                          style={{ color: 'black' }}
                                          placeholder="Enter Password"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                          <hr className="my-4" />
                          <div className="col">
                            <Col>
                              <h3 className="mb-0">CHOOSE PERMISSION</h3>
                            </Col>
                            <div style={{ marginTop: '20px' }} className="pl-lg">
                              <Row>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                    htmlFor="input-city"
                                  >
                                    Technicians
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'technician_add')} /> {' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'technician_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'technician_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                    htmlFor="input-city"
                                  >
                                    Tenants
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'tenants_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'tenants_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'tenants_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label">
                                    Banners
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'banner_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'banner_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'banner_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Category
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'category_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'category_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'category_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Location
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'location_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'location_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'location_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Notification
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'notification_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'notification_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'notification_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div style={{ marginTop: '20px' }} className="pl-lg">
                              <Row>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                    htmlFor="input-city"
                                  >
                                    Services
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'services_add')} /> {' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'services_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'services_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Places
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'places_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'places_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'places_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Parts Inventory
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'parts_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'parts_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'parts_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Priority
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'priority_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'priority_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'priority_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Users
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'users_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'users_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'users_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Workorder
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'workorder_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'workorder_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'workorder_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div style={{ marginTop: '20px' }} className="pl-lg">
                              <Row>
                                <Col lg="2">
                                  <label style={{ paddingLeft: '20px' }}
                                    className="form-control-label"
                                  >
                                    Settings
                                  </label>
                                  <div style={{ paddingLeft: '20px' }}>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'settings_add')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Add</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'settings_edit')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}> Edit</span>
                                      </div>
                                    </FormGroup>
                                    <FormGroup check>
                                      <div class="checkbox-mirror">
                                        <Input type="checkbox" onChange={(e) => onChangePermission(e.target.checked, 'settings_delete')} />{' '}
                                        <span style={{ color: '#2FBBC1', fontSize: '13px', listStyle: 'none' }}>Delete</span>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Col>

                              </Row>
                            </div>
                          </div>
                          <Col md="6">
                            <div style={{ paddingBottom: '30px', padding: '20px' }}>
                              <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: loading ? 'green' : '#044057', margin: '10px 0px 10px 0px', color: 'white', width: '70%', borderRadius: '12px', border: 0, padding: '15px 22px 15px 22px', fontSize: '1rem' }} >
                                {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                                SUBMIT
                              </Button>{' '}
                            </div>
                          </Col>
                        </form>
                      )}
                    />
                  </Card>
                </div>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <div className=" modal-header">
        </div>
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={erroropen} size="sm">
        <div style={{ color: 'red', padding: 15, marginTop: 15 }}>{errors}</div>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
          <Button onClick={() => setErroropen(false)} style={{ backgroundColor: '#09577C', color: 'white', border: 0 }} type="button">OK</Button>
        </div>
      </Modal>
    </>
  );
};

export default UserCreate;
